import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

export const RuntimeUiFlowSessionsRoutes: Routes = [
  {
    path: '',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultApplicationPermissionsGuard('ui_flow_session_read')],
    loadComponent: () =>
      import('@flowx/designer/modules/ui-flow/pages/ui-flow-sessions/ui-flow-sessions.page').then(
        ({ UiFlowSessionsPageComponent }) => UiFlowSessionsPageComponent
      ),
  },
  {
    path: ':uuid',
    canActivate: [DefaultApplicationPermissionsGuard('ui_flow_session_read')],
    loadComponent: () =>
      import('../ui-flow/pages/ui-flow-session-details/ui-flow-session-details.component').then(
        ({ UiFlowSessionDetailsComponent }) => UiFlowSessionDetailsComponent
      ),
  },
]
